import {
  PortfolioOrderStates,
  PortfolioOrderTypes,
} from '@/utils/constants/portfolioConstants';

export function isOrderPending(
  orderState: PortfolioOrderStates | string | null | undefined
): boolean {
  return orderState === PortfolioOrderStates.PENDING;
}

export function isOrderCancelled(
  orderState: PortfolioOrderStates | string | null | undefined
): boolean {
  return (
    orderState === PortfolioOrderStates.CANCELLED ||
    orderState === PortfolioOrderStates.MANUALLY_CANCELLED
  );
}

export function isLimitPriceOrderType(
  orderType: PortfolioOrderTypes | string | null | undefined
): boolean {
  return orderType === PortfolioOrderTypes.LIMIT_PRICE;
}

export function isMarketPriceOrderType(
  orderType: PortfolioOrderTypes | string | null | undefined
): boolean {
  return orderType === PortfolioOrderTypes.MARKET_PRICE;
}

export function isOrderCancellable(
  orderState: PortfolioOrderStates | string | null | undefined,
  orderType: PortfolioOrderTypes | string | null | undefined
): boolean {
  return (
    isOrderPending(orderState as PortfolioOrderStates) &&
    isLimitPriceOrderType(orderType)
  );
}

export function getOrderDate(
  orderState: PortfolioOrderStates | string | null,
  {
    completionDate,
    orderCancellationDate,
    creationDate,
  }: {
    completionDate: string | null;
    orderCancellationDate: string | null;
    creationDate: string;
  }
): string | null {
  switch (orderState) {
    case PortfolioOrderStates.COMPLETED:
      return completionDate;
    case PortfolioOrderStates.CANCELLED:
    case PortfolioOrderStates.MANUALLY_CANCELLED:
      return orderCancellationDate;
    case PortfolioOrderStates.PENDING:
      return creationDate;
    default:
      return null;
  }
}
